import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=ccfd8c7a&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/AudioPlayer/AudioPlayer.less?vue&type=style&index=0&id=ccfd8c7a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfd8c7a",
  null
  
)

export default component.exports